module.exports = __webpack_public_path__ + "media/images/lightbox/play-button-2fb7b5238b347adcc34bb028fb0a8e99.png";